import React from 'react';
import AccordionDetails from '@material-ui/core/AccordionDetails';

const CustomAccordionDetails = (props) => {
    return <AccordionDetails {...props} />;
};

export { CustomAccordionDetails as AccordionDetails };
